import type {GroupDataDto} from '@/global/api/gen/ts/GroupDataDto';
import type {ModalSystemProps} from '@/global/providers/ModalProvider';
import {useTranslation} from 'react-i18next';
import React, {useState} from 'react';
import {apiAttachDriverToGroup} from '@/modules/groups/services/group.service';
import {Button, Dialog, DialogContent, DialogTitle, Stack, Typography} from '@mui/material';
import {toast} from "react-toastify";
import type {EmployeeInfoDto} from "@/global/api/gen/ts/EmployeeInfoDto";
import {DriversAutocomplete} from "@/global/components/Autocompletes/DriversAutocomplete";

interface DriversModalProps {
    groupInfo: GroupDataDto;
}

export function DriversModal({groupInfo, open, close}: ModalSystemProps<DriversModalProps>) {

    const {t} = useTranslation();

    const [driverId, setDriverId] = useState<number | null>(null);

    const {mutate} = apiAttachDriverToGroup();

    const handleSelectChange = (value: EmployeeInfoDto | null) => {
        setDriverId(value?.id ?? null);
    };

    const handleAttach = () => {

        if (!groupInfo.id || !driverId) {
            toast.error(t('school_page.group_page.attributes_window.modal.required.driver'));
            return;
        }

        const driverDto = {
            group_id: groupInfo.id,
            driver_id: Number(driverId)
        };

        mutate(driverDto, {
            onSuccess: () => {
                close(0);
            }
        });
    };

    return (
        <Dialog
            open={open}
            onClose={() => close(5)}
        >
            <DialogTitle>
                {t('school_page.group_page.attributes_window.modal.add_dialog.driver')}
                {' '}
                <i>
                    <b>
                        {groupInfo.title}
                    </b>
                </i>
            </DialogTitle>
            <DialogContent>
                <Stack gap={2}>
                    <DriversAutocomplete
                        onChange={handleSelectChange}
                        groupInfo={groupInfo}
                    />

                    <Typography
                        variant="body2"
                        sx={{mt: 1}}
                    >
                        {t('school_page.group_page.attributes_window.modal.reminder.driver')}
                    </Typography>

                    <Button onClick={handleAttach}>
                        Прикрепить мастера обучения вождению
                    </Button>
                </Stack>
            </DialogContent>
        </Dialog>
    );
}
